"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _admins = require("@/api/admins");
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _index2 = require("@/utils/index");
var _excel = require("@/utils/excel");
var _adminsRoles = require("@/api/admins-roles");
var _index3 = _interopRequireDefault(require("@/components/Enabled/index.vue"));
var _admin = require("@/store/modules/admin");
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.rolesList = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.loggedInAdmin = null;
    this.listQuery = {
      page: 1,
      limit: 10,
      fullName: undefined,
      emailAddress: undefined,
      mobileNumber: undefined,
      'adminsRole.name': undefined,
      enabled: true,
      sort: 'id,ASC',
      filter: {
        fullName: '$contL',
        emailAddress: '$contL',
        mobileNumber: 'starts',
        enabled: '$eq',
        'adminsRole.name': '$eq'
      }
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
  }
  created() {
    // get logged in admin
    this.loggedInAdmin = _admin.AdminModule;
    // get all amdins
    this.getList();
    // fetch admin roles
    this.getAdminRoles();
  }
  async getList() {
    try {
      this.listLoading = true;
      const data = await (0, _admins.getAdmins)((0, _index2.getQuery)(this.listQuery));
      for (const admin of data.data) {
        admin.emailAddress = this.maskSensitiveInfo(admin.emailAddress);
        admin.fullName = this.maskSensitiveInfo(admin.fullName);
        admin.mobileNumber = this.maskSensitiveInfo(admin.mobileNumber);
      }
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  maskSensitiveInfo(input) {
    if (input.includes('@')) {
      // If it's an email
      const atIndex = input.indexOf('@');
      return input.slice(0, atIndex - 3) + '*' + input.slice(atIndex);
    } else if (input.match(/^\d+$/)) {
      // If it's a mobile number
      return input.slice(0, -4).replace(/\d/g, '*') + input.slice(-4);
    } else {
      // Otherwise, assuming it's a full name
      const nameParts = input.split(' ');
      return nameParts.map((part, index) => index === 0 ? part : '*'.repeat(part.length)).join(' ');
    }
  }
  async getAdminRoles() {
    try {
      this.listLoading = true;
      this.rolesList = await (0, _adminsRoles.getRoles)((0, _index2.getQuery)({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq'
        }
      }));
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  sortChange(data) {
    const {
      prop,
      order
    } = data;
    if (prop) {
      this.listQuery.sort = `${prop},` + (order === 'ascending' ? 'ASC' : 'DESC');
      this.handleFilter();
    }
  }
  getSortClass(key) {
    const sort = this.listQuery.sort;
    return sort === `${key},ASC` ? 'ascending' : sort === `${key},DESC` ? 'descending' : '';
  }
  handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['ID', 'Full Name', 'Email', 'Mobile Number', 'Status', 'timestamp'];
    const filterVal = ['id', 'fullName', 'emailAddress', 'mobileNumber', 'enabled', 'createdTimestamp'];
    const data = (0, _index2.formatJson)(filterVal, this.list);
    (0, _excel.exportJson2Excel)(tHeader, data, this.$tc('route.adminManagement.admins.title'));
    this.downloadLoading = false;
  }
  get isSuperAdmin() {
    if (!this.loggedInAdmin) {
      return false;
    }
    const loggedInRole = this.loggedInAdmin.roles && this.loggedInAdmin.roles[0] || this.loggedInAdmin.adminsRole && this.loggedInAdmin.adminsRole.name || '';
    return loggedInRole === 'Super Admin';
  }
  canEdit(admin = null) {
    // 1. Basic null check
    if (!admin || !this.loggedInAdmin) {
      return false;
    }
    const loggedInRole = this.loggedInAdmin.roles && this.loggedInAdmin.roles[0] || this.loggedInAdmin.adminsRole && this.loggedInAdmin.adminsRole.name || '';
    const targetRole = admin.adminsRole ? admin.adminsRole.name : '';
    // 2. System Admin can edit anyone
    if (loggedInRole === 'System Admin') {
      return true;
    }
    // 3. Prevent non-System Admin users from editing themselves
    if (admin.id === this.loggedInAdmin.id) {
      return false;
    }
    // 4. Super Admin can edit anyone EXCEPT System Admin
    if (loggedInRole === 'Super Admin' && targetRole !== 'System Admin') {
      return true;
    }
    // Default: Disallow editing for any other scenarios
    return false;
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'AdminList',
  components: {
    Pagination: _index.default,
    Enabled: _index3.default
  }
})], default_1);
var _default = exports.default = default_1;